<template>
  <div class="selection">
    <BaseSwiper
      @slide-change="onSlideChange($event)"
      @slide-change-transition-end="onSlideChangeEnd($event)"
      @progress="$store.commit('ui/setOpponentSelectionProgress', $event)"
      :options="{ nested: true, initialSlide }">
      <SwiperSlide v-for="(opponent, i) in opponents" :key="i">
        <OpponentProfile
          ref="base-opponent-profile"
          :opponent="opponent"
          :number-image="require(`@/assets/img/number-icon-${i + 1}.svg`)"
          :unlocked="opponentUnlockedStates[opponent.id]"
        />
      </SwiperSlide>
      <SwiperSlide>
        <ComingSoon/>
      </SwiperSlide>
    </BaseSwiper>
  </div>
</template>

<script>
import SwiperSlide from '@/components/BaseSwiper/components/SwiperSlide/SwiperSlide'
import BaseSwiper from '@/components/BaseSwiper/BaseSwiper'
import ComingSoon from './partials/ComingSoon/ComingSoon'
import OpponentProfile from './partials/OpponentProfile/OpponentProfile'
import { opponentIds, opponentsById } from '@/data/opponents'
import { mapGetters } from 'vuex'
export default {
  components: {
    BaseSwiper,
    SwiperSlide,
    ComingSoon,
    OpponentProfile
  },
  props: {
    initialSlide: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters('user', [
      'opponentUnlockedStates',
      'userHasBeatenAllOpponents'
    ]),
    opponents () {
      return opponentIds.map(id => opponentsById[id])
    }
  },
  methods: {
    onSlideChange (currentIndex) {
      const component = this.$refs['base-opponent-profile'][currentIndex]
      component && component.tl.play(0)
    },
    onSlideChangeEnd (currentIndex) {
      this.$store.commit('ui/setActiveOpponentSlide', currentIndex)
      this.$refs['base-opponent-profile'].forEach((component, i) => {
        if (i !== currentIndex) component.tl.pause(0)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.selection {
  width: 100%;
  height: 100%;
  display: flex;
}
::v-deep .swiper,
::v-deep .swiper-wrapper {
  height: 100%;
}
::v-deep .pagination {
  padding: var(--spacing-1);
}
</style>
